export const html: string =
`<form data-myon-attr-class="searchUg {{ !dark? | '-light' }}">
	<fieldset class="searchUg_group -limit searchUg_textFields g_resetFieldset">
		<legend class="g_screenReader">{{ lang.LIMIT_SEARCH_TO }}</legend>
		<div class="flex -row -centerLeft -gutter">
			<h2 class="searchUg_listHeader flex_item" aria-hidden="true">{{ lang.LIMIT_SEARCH_TO }}</h2>
			<ul class="searchUg_list flex_item" data-myon-name="searchBtns">
				<li class="searchUg_listItem searchUg_labelledCheckbox" data-myon-template="searchFields">
					<input class="checkbox {{ dark? | '-darkContainer' }}" data-myon-name="checkbox" type="checkbox" id="search-ctl-{{ id }}" name="search[]" value="{{ id }}"/>
					<label for="search-ctl-{{ id }}">{{ label }}</label>
				</li>
			</ul>
			<span class="flex_item -grow" role="presentation"></span>
			<button type="button" class="button {{ dark? | '-darkContainer' }} flex_item" data-myon-on-click="handleResetButtonClick" aria-label="{{ lang.LABEL_CLEAR_FILTERS }}">
				<i class="button_icon mycon -return"></i>
				<span class="button_text">{{ lang.LABEL_CLEAR }}</span>
			</button>
		</div>
	</fieldset>

	<div class="searchUg_group" data-myon-name="tabset">
		<div class="searchUg_list g_resetUl" data-myon-name="tabThumbContainer">
			<button type="button" class="searchUg_listItem searchUg_tabButton button" data-myon-template="tabs">
				<i class="searchUg_buttonIcon {{ iconClass }}  {{ !dark? | '-light' }}"></i>
				<span>{{ label }}</span>
			</button>
		</div>
		<div data-myon-name="filterDisplay" class="searchUg_controls">
			<div class="searchUg_controlsInner" data-myon-name="tabPanelContainer">
				<fieldset data-myon-name="fictionFilter" class="g_resetFieldset">
					<legend class="g_screenReader">{{ lang.LABEL_FICTION_GROUP }}</legend>
					<ul class="searchUg_list">
						<li data-myon-template="fictionToggles" class="searchUg_listItem searchUg_labelledCheckbox">
							<input type="checkbox" class="checkbox {{ dark? | '-darkContainer' }} -beefy" name="fiction[{{ id }}]" aria-label="{{ label }}" value="{{ id }}" id="filter-fiction-{{ id }}">
							<label for="filter-fiction-{{ id }}">{{ label }}</label>
						</li>
					</ul>
				</fieldset>
				<div hidden="hidden" data-myon-name="lexileFilter">
					<div data-myon-name="lexileLabel" class="searchUg_sliderDisplay"></div>
				</div>
				<div hidden="hidden" data-myon-name="atosFilter">
					<div data-myon-name="atosLevelLabel" class="searchUg_sliderDisplay"></div>
				</div>
				<div hidden="hidden" data-myon-name="guidedReadingFilter">
					<div data-myon-name="guidedReadingLabel" class="searchUg_sliderDisplay"></div>
				</div>
				<div hidden="hidden" data-myon-name="gradeLevelFilter">
					<div data-myon-name="gradeLevelLabel" class="searchUg_sliderDisplay"></div>
				</div>
				<div hidden="hidden" data-myon-name="languageFilter">
					<fieldset class="g_resetFieldset">
						<legend class="g_screenReader">{{ lang.LABEL_LANGUAGE }}</legend>
						<ul class="searchUg_grid">
							<li data-myon-template="languageToggles" class="searchUg_toggle" lang="{{ lang }}">
								<input type="checkbox" class="checkbox {{ dark? | '-darkContainer' }} -beefy" name="language[]" value="{{ id }}" aria-label="{{ label }}" id="filter-language-{{ id }}">
								<label class="searchUg_toggleLabel" for="filter-language-{{ id }}">{{ label }}</label>
							</li>
						</ul>
					</fieldset>
				</div>
				<div hidden="hidden" class="flex -center" data-myon-name="storyLengthFilter">
					<fieldset class="g_resetFieldset searchUg_subGroup" >
						<legend class="g_screenReader">{{ lang.LABEL_STORY_LENGTH }}</legend>
						<h3 aria-hidden="true" class="searchUg_groupHeader">{{ lang.LABEL_STORY_LENGTH }}</h3>
						<ul class="searchUg_list">
							<li class="searchUg_listItem searchUg_labelledCheckbox -vertical" data-myon-template="lengthBtns" data-myon-hook-add="handleRadioAdd">
								<input data-myon-prop-checked="{{ selected? }}" type="radio" class="radio" name="length" value="{{ id }}" id="filter-length-{{ id }}" aria-label="{{ label }}">
								<label for="filter-length-{{ id }}">{{ label }}</label>
							</li>
						</ul>
					</fieldset>
					<fieldset class="g_resetFieldset searchUg_subGroup" >
						<legend class="g_screenReader">{{ lang.LABEL_AUDIO }}</legend>
						<h3 aria-hidden="true" class="searchUg_groupHeader">{{lang.LABEL_AUDIO }}</h3>
						<ul class="searchUg_list">
							<li class="searchUg_listItem searchUg_labelledCheckbox -vertical" data-myon-template="audioBtns" data-myon-hook-add="handleRadioAdd">
								<input type="radio" class="radio" name="audio" data-myon-prop-checked="{{ selected? }}" id="filter-audio-{{ id }}" value="{{ id }}" aria-label="{{ label }}">
								<label for="filter-audio-{{ id }}">{{ label }}</label>
							</li>
						</ul>
					</fieldset>
				</div>
			</div>
		</div>
	</div>
</form>`;
